export const menu = {
  manage: 'Manage',
  configuration: 'Configuration templates',
  configurationDesc: 'View and manage configuration templates',
  configurationNew: 'Create new configuration template',
  configurationNewDesc: 'Create a new configuration template',
  users: 'Users',
  files: 'Files',
  filesDesc: 'Manage and view application files',
  statistics: 'Statistics',
  statisticsDesc: 'Browse charts and statistical data',
  roles: 'Roles',
  rolesDesc: 'Manage user roles',
  usersDesc: 'Manage users',
  configurationFinished: 'Finished configurations',
  configurationFinishedDesc: 'View finished configuration templates',
  logsDesc: 'Browse query and command logs',
  criteriaDesc: 'Define possible future configurations',
}
